<template>
	<div class="fixed inset-0 flex items-center justify-center bg-trans-gray z-20" v-show="show">
		<div class="rounded text-red-700 shadow bg-red-100">
			<div class="p-4">
				<h1 class="text-center text-2xl font-bold mb-4">
					Are you sure?
				</h1>
				<p class="text-center text-gray-700 mb-6">
					{{initTerm}} cannot be undone.
				</p>
			</div>
			<div class="rounded-b bg-red-200 px-4 py-2">
				<div class="flex items-center justify-between">
					<action-button class="link link-red" @button-clicked="cancel">cancel</action-button>
					<action-button class="btn btn-red" @button-clicked="confirmDelete">Yes</action-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['show', 'deleteObject', 'term'],
	data () {
		return {
			initObject: this.deleteObject,
			initTerm: this.term || 'Deleting'
		}
	},
	methods: {
		cancel () {
			this.$emit('close')
		},
		confirmDelete () {
			this.$emit('delete', this.initObject)
		}
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		const listener = document.addEventListener('keydown', e => {
			if (this.show && e.keyCode === 27) {
				this.cancel()
			}
		})

		this.$once('hook:beforeDestroy', () => {
			document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		})
	}
}
</script>
